// src/pages/LegalPage.jsx
import React, { useState } from 'react';

const LAST_UPDATED = '31 de julio de 2026';

const AI_DISCLAIMER =
  'Este documento fue redactado con asistencia de IA como base inicial; recomendamos revisión por un abogado antes de considerarlo definitivo.';

// ─── TÉRMINOS Y CONDICIONES DE USO ─────────────────────────────────────────
const TERMS_SECTIONS = [
  {
    id: 'quienes-somos',
    title: '1. Quiénes somos',
    paragraphs: [
      'Tarot Místico (tarotmistico.lat) es un emprendimiento digital operado por una persona física con domicilio en Argentina, no una sociedad ni una corporación. A los efectos de estos Términos y Condiciones, nos referimos a nosotros como "Tarot Místico", "nosotros" o "el servicio", y a quien usa la app como "vos" o "el usuario".',
      'Podés contactarnos por cualquier consulta general a contacto@tarotmistico.lat, por soporte técnico a support@tarotmistico.lat, y por temas de pagos y facturación a pagos@tarotmistico.lat.',
    ],
  },
  {
    id: 'objeto',
    title: '2. Qué ofrecemos',
    paragraphs: [
      'Tarot Místico ofrece lecturas de tarot con interpretación generada mediante inteligencia artificial, una lectura gratuita del día, horóscopos y contenido de astrología, y cursos online de tarot de acceso inmediato mediante pago.',
      'Algunas funciones son gratuitas (por ejemplo, la carta del día y una primera lectura premium de cortesía) y otras son pagas. El detalle de precios y qué incluye cada tirada o curso se muestra siempre antes de confirmar un pago.',
    ],
  },
  {
    id: 'finalidad-entretenimiento',
    title: '3. Finalidad de entretenimiento y autoconocimiento — no es asesoramiento profesional',
    paragraphs: [
      'Las lecturas de tarot, horóscopos y cualquier contenido interpretativo que ofrece Tarot Místico tienen fines de entretenimiento, reflexión y autoconocimiento. No constituyen, no reemplazan y no deben interpretarse como asesoramiento médico, legal, financiero, psicológico ni de ningún otro tipo profesional.',
      'Si estás atravesando una situación de salud física o mental, una decisión legal o financiera importante, o cualquier situación que requiera ayuda profesional, te recomendamos consultar a un profesional matriculado en la materia. No tomes decisiones importantes de tu vida basándote únicamente en una lectura de tarot.',
      'Tarot Místico no garantiza resultados, predicciones certeras ni consecuencias específicas derivadas del uso del servicio.',
    ],
  },
  {
    id: 'uso-de-ia',
    title: '4. Uso de inteligencia artificial (Groq / LLaMA 3.3)',
    paragraphs: [
      'Las interpretaciones premium de tarot y los horóscopos se generan con la ayuda de un modelo de lenguaje de inteligencia artificial provisto por Groq (modelo LLaMA 3.3). Para poder generar tu interpretación, tu pregunta al oráculo, los datos de la tirada (cartas obtenidas, posiciones) y, cuando corresponde, tu nombre y fecha de nacimiento se envían a la infraestructura de Groq para su procesamiento.',
      'Groq actúa como proveedor tecnológico externo (encargado de tratamiento) y procesa esta información únicamente para generar el texto de la interpretación. No usamos tu información para entrenar modelos propios ni la vendemos a terceros.',
      'Si el servicio de IA no está disponible, la app puede ofrecer lecturas con interpretaciones locales predefinidas en lugar de interpretaciones generadas dinámicamente.',
    ],
  },
  {
    id: 'cuenta-sin-registro',
    title: '5. Cuenta sin registro y código de recuperación',
    paragraphs: [
      'Tarot Místico no requiere que crees una cuenta con usuario y contraseña. En cambio, usamos un sistema de "cuenta sin registro": cuando comprás un curso o guardás una lectura en tu diario, el servidor genera automáticamente un código de recuperación secreto y único.',
      'Ese código se guarda en tu dispositivo (localStorage del navegador) y también en una base de datos alojada en Supabase (Postgres), con servidores ubicados en São Paulo, Brasil. Antes de comprar un curso o guardar una lectura, no se crea ni se guarda ningún código: el sistema es completamente anónimo hasta ese momento.',
      'El código de recuperación te permite acceder a tus cursos comprados y a tus lecturas guardadas desde otro dispositivo, ingresándolo manualmente. Es tu responsabilidad guardar ese código en un lugar seguro.',
      'IMPORTANTE: si perdés tu código de recuperación, no existe forma automática de recuperar el acceso a tus compras o lecturas. Esta pérdida es irreversible salvo que hayas cargado un email de respaldo en tu cuenta; en ese caso, podés escribirnos para verificar tu identidad manualmente y evaluar la recuperación de tu acceso, aunque esto no es un proceso automático ni instantáneo.',
    ],
  },
  {
    id: 'referidos',
    title: '6. Sistema de referidos',
    paragraphs: [
      'Cualquier usuario puede generar un código de referido público para compartir con otras personas. Cuando alguien realiza una compra usando tu código, tenés derecho a una comisión del 20% sobre el monto efectivamente cobrado por esa venta.',
      'Las comisiones se calculan sobre pagos confirmados y acreditados. Si una venta referida es reembolsada total o parcialmente, la comisión correspondiente se ajusta o se anula en la misma proporción.',
      'Nos reservamos el derecho de suspender códigos de referido usados de forma fraudulenta, abusiva o contraria a estos Términos (por ejemplo, autorreferidos para generar comisiones artificiales).',
      'El pago de comisiones de referidos se coordina de forma directa vía contacto@tarotmistico.lat o pagos@tarotmistico.lat.',
    ],
  },
  {
    id: 'pagos',
    title: '7. Pagos y precios',
    paragraphs: [
      'Los pagos se procesan a través de Mercado Pago (para pagos en pesos argentinos) y PayPal (para pagos internacionales). No almacenamos números de tarjeta ni datos sensibles de pago en nuestros servidores: esa información es manejada directamente por Mercado Pago y PayPal conforme a sus propias políticas.',
      'Los precios de las tiradas premium y los cursos se muestran en dólares estadounidenses (USD), con una conversión aproximada a pesos argentinos (ARS) al momento del pago cuando corresponde. Esa conversión puede variar según el tipo de cambio vigente.',
      'Los cursos son contenido digital de acceso inmediato: no hay envío físico ni entrega material. El acceso se habilita automáticamente al confirmarse el pago.',
    ],
  },
  {
    id: 'propiedad-intelectual',
    title: '8. Propiedad intelectual',
    paragraphs: [
      'Los textos, diseños, ilustraciones, estructura de los cursos y demás contenidos originales de Tarot Místico son propiedad de Tarot Místico o de sus licenciantes, y están protegidos por la normativa de propiedad intelectual aplicable.',
      'No está permitido copiar, redistribuir, revender ni reproducir el contenido pago de la app (cursos, interpretaciones) sin autorización previa por escrito.',
    ],
  },
  {
    id: 'uso-aceptable',
    title: '9. Uso aceptable',
    paragraphs: [
      'Te comprometés a usar Tarot Místico de buena fe y a no intentar vulnerar la seguridad del sitio, abusar del sistema de referidos, ni utilizar el servicio con fines ilícitos.',
      'Nos reservamos el derecho de restringir el acceso a usuarios que hagan un uso indebido del servicio.',
    ],
  },
  {
    id: 'menores',
    title: '10. Menores de edad',
    paragraphs: [
      'El servicio está pensado para personas mayores de 18 años. Si sos menor de edad, te pedimos que uses la app junto con un adulto responsable, en particular para cualquier compra.',
    ],
  },
  {
    id: 'disponibilidad',
    title: '11. Disponibilidad del servicio',
    paragraphs: [
      'Hacemos nuestro mejor esfuerzo para mantener el servicio disponible, pero al tratarse de un emprendimiento chico que depende de proveedores externos (hosting, IA, pagos), no podemos garantizar disponibilidad ininterrumpida. Podés reportar caídas o errores a support@tarotmistico.lat.',
    ],
  },
  {
    id: 'responsabilidad',
    title: '12. Limitación de responsabilidad',
    paragraphs: [
      'En la máxima medida permitida por la ley, Tarot Místico no será responsable por daños indirectos, pérdidas económicas, decisiones personales o consecuencias derivadas de la interpretación o el uso del contenido del servicio, dado su carácter de entretenimiento y autoconocimiento descrito en la sección 3.',
      'Tampoco somos responsables por fallas atribuibles a terceros proveedores (Groq, Mercado Pago, PayPal, Supabase, hosting) que estén fuera de nuestro control razonable.',
    ],
  },
  {
    id: 'modificaciones',
    title: '13. Modificaciones a estos Términos',
    paragraphs: [
      `Podemos actualizar estos Términos y Condiciones en cualquier momento para reflejar cambios en el servicio o en la normativa aplicable. La fecha de la última actualización figura al inicio de este documento (${LAST_UPDATED}). El uso continuado del servicio después de una actualización implica la aceptación de los nuevos términos.`,
    ],
  },
  {
    id: 'ley-aplicable',
    title: '14. Ley aplicable y jurisdicción',
    paragraphs: [
      'Estos Términos se rigen por las leyes de la República Argentina. Para cualquier controversia que no pueda resolverse de forma amistosa, las partes se someten a los tribunales ordinarios competentes de Argentina.',
    ],
  },
];

// ─── POLÍTICA DE PRIVACIDAD ─────────────────────────────────────────────────
const PRIVACY_SECTIONS = [
  {
    id: 'responsable',
    title: '1. Responsable del tratamiento de datos',
    paragraphs: [
      'El responsable del tratamiento de tus datos personales en el marco del uso de Tarot Místico (tarotmistico.lat) es la persona física que opera este emprendimiento en Argentina. Podés contactarnos para cualquier tema de privacidad a contacto@tarotmistico.lat o support@tarotmistico.lat.',
    ],
  },
  {
    id: 'que-datos',
    title: '2. Qué datos recolectamos',
    paragraphs: [
      'Recolectamos los siguientes datos, según qué funciones uses:',
    ],
    list: [
      'Nombre y fecha de nacimiento: para personalizar tu lectura y calcular información astrológica.',
      'Tu pregunta al oráculo: el texto que escribís antes de una tirada, usado para enfocar la interpretación.',
      'Cartas y posiciones de cada tirada: para generar y guardar la interpretación.',
      'Email de respaldo (opcional): solo si decidís cargarlo, para poder verificar tu identidad manualmente en caso de pérdida del código de recuperación.',
      'Datos de pago: procesados directamente por Mercado Pago y PayPal; nosotros no vemos ni almacenamos números de tarjeta.',
      'Código de referido (si creás uno) y datos mínimos de las ventas asociadas, para calcular comisiones.',
      'Datos técnicos básicos de uso (por ejemplo, errores de la app) con fines de soporte y mejora del servicio.',
    ],
  },
  {
    id: 'como-se-almacenan',
    title: '3. Cómo y dónde se almacenan tus datos',
    paragraphs: [
      'Por defecto, tus datos (nombre, fecha de nacimiento, lecturas) se guardan localmente en tu propio dispositivo, en el almacenamiento local (localStorage) del navegador. No se envían a ningún servidor nuestro solo por usar la app o hacer una lectura gratuita.',
      'Recién si comprás un curso o guardás una lectura en tu diario, se genera un código de recuperación y se envían a una base de datos en Supabase (Postgres) —cuyos servidores están ubicados en São Paulo, Brasil— los datos necesarios para vincular esa compra o lectura a tu código: el código en sí, el curso o la lectura guardada, y el email de respaldo si lo cargaste.',
      'Esto significa que, si nunca comprás un curso ni guardás una lectura, tus datos personales no salen de tu dispositivo (más allá del envío puntual a Groq para generar cada interpretación, ver sección 4).',
    ],
  },
  {
    id: 'con-quien-compartimos',
    title: '4. Con quién compartimos tus datos',
    paragraphs: [
      'No vendemos tus datos personales a terceros. Compartimos información limitada únicamente con los proveedores estrictamente necesarios para operar el servicio:',
    ],
    list: [
      'Groq (proveedor de inteligencia artificial, modelo LLaMA 3.3): recibe tu pregunta al oráculo y los datos de la tirada para generar la interpretación de tarot u horóscopo. Groq procesa esta información para nosotros y bajo sus propias políticas de privacidad.',
      'Mercado Pago y PayPal: procesan tus pagos de forma directa. Reciben los datos necesarios para completar la transacción (por ejemplo, monto y descripción del producto); nosotros no accedemos a tus datos de tarjeta.',
      'Supabase: aloja la base de datos (Postgres, en São Paulo, Brasil) donde se guarda tu código de recuperación y los datos asociados, solo si comprás un curso o guardás una lectura.',
      'Vercel: aloja la aplicación web y las funciones de servidor (API) que la hacen funcionar.',
    ],
  },
  {
    id: 'transferencias-internacionales',
    title: '5. Transferencias internacionales de datos',
    paragraphs: [
      'Dado que usamos proveedores con infraestructura fuera de Argentina (Supabase en Brasil; Groq, Mercado Pago, PayPal y Vercel con infraestructura que puede estar en distintos países, incluido Estados Unidos), tus datos pueden transferirse y procesarse fuera de Argentina. Estos proveedores son empresas reconocidas que cuentan con sus propias políticas de seguridad y privacidad.',
    ],
  },
  {
    id: 'finalidad',
    title: '6. Para qué usamos tus datos',
    paragraphs: [
      'Usamos tus datos exclusivamente para: generar y mostrarte tus lecturas e interpretaciones, permitirte guardar y recuperar tus lecturas y cursos comprados mediante tu código de recuperación, procesar pagos, calcular comisiones de referidos, y brindarte soporte cuando nos escribís.',
      'No usamos tus datos para publicidad de terceros ni los cedemos con fines comerciales ajenos al servicio.',
    ],
  },
  {
    id: 'conservacion',
    title: '7. Conservación de datos',
    paragraphs: [
      'Conservamos los datos asociados a tu código de recuperación mientras la cuenta esté activa o hasta que solicites su eliminación. Los datos guardados solo en tu dispositivo permanecen ahí hasta que borres el almacenamiento local del navegador o nos pidas su baja si ya fueron sincronizados.',
    ],
  },
  {
    id: 'derechos',
    title: '8. Tus derechos sobre tus datos',
    paragraphs: [
      'Podés solicitarnos en cualquier momento el acceso, la rectificación o la eliminación de los datos asociados a tu código de recuperación, escribiendo a contacto@tarotmistico.lat o support@tarotmistico.lat e indicando tu código (o el email de respaldo cargado, si lo tenés) para que podamos identificar tu registro.',
      'Ten en cuenta que, si solicitás la eliminación de tu código y sus datos asociados, perderás el acceso a los cursos y lecturas vinculados a ese código, de forma irreversible.',
    ],
  },
  {
    id: 'seguridad',
    title: '9. Seguridad',
    paragraphs: [
      'Tomamos medidas razonables para proteger tu información (por ejemplo, no exponer tokens de pago en el cliente y usar conexiones seguras), pero, como cualquier servicio en internet, no podemos garantizar seguridad absoluta. Te recomendamos no compartir tu código de recuperación con nadie.',
    ],
  },
  {
    id: 'cookies',
    title: '10. Cookies y almacenamiento local',
    paragraphs: [
      'Usamos almacenamiento local del navegador (localStorage) para guardar tus preferencias, tu carta del día, tus lecturas y tu código de recuperación en tu propio dispositivo. No usamos cookies de rastreo publicitario de terceros.',
    ],
  },
  {
    id: 'menores-privacidad',
    title: '11. Menores de edad',
    paragraphs: [
      'No recolectamos deliberadamente datos de menores de 18 años sin la supervisión de un adulto responsable.',
    ],
  },
  {
    id: 'cambios-privacidad',
    title: '12. Cambios a esta política',
    paragraphs: [
      `Podemos actualizar esta Política de Privacidad para reflejar cambios en el servicio o nuevos requisitos legales. Última actualización: ${LAST_UPDATED}.`,
    ],
  },
];

// ─── POLÍTICA DE REEMBOLSOS ─────────────────────────────────────────────────
const REFUNDS_SECTIONS = [
  {
    id: 'alcance',
    title: '1. Alcance de esta política',
    paragraphs: [
      'Esta Política de Reembolsos aplica a las dos categorías de productos pagos de Tarot Místico: lecturas de tarot premium con interpretación por IA, y cursos online. Ambas son productos digitales de acceso y entrega inmediata, sin envío físico.',
    ],
  },
  {
    id: 'lecturas',
    title: '2. Lecturas de tarot premium',
    paragraphs: [
      'Una lectura premium se genera y se entrega en el momento, apenas confirmás el pago. Por su naturaleza de contenido digital consumido instantáneamente, las lecturas ya generadas no son reembolsables, salvo en los siguientes casos:',
    ],
    list: [
      'Cobro duplicado o error de facturación comprobable.',
      'Falla técnica de nuestro sistema que impidió que recibieras la lectura pese al cobro efectivo (por ejemplo, un error del oráculo AI que dejó la interpretación vacía y no se pudo regenerar).',
    ],
    paragraphs2: [
      'En estos casos, escribinos a pagos@tarotmistico.lat dentro de las 72 horas de realizada la compra, con el comprobante de pago, para que evaluemos el reembolso o la regeneración de la lectura sin costo.',
    ],
  },
  {
    id: 'cursos',
    title: '3. Cursos online',
    paragraphs: [
      'Los cursos son contenido digital de acceso inmediato. Aplicamos la siguiente política, clara y específica:',
    ],
    list: [
      'Reembolso completo: si solicitás la baja dentro de las 72 horas posteriores a la compra Y todavía no accediste a ningún módulo ni lección del curso, te reembolsamos el 100% del importe pagado.',
      'Reembolso parcial o a criterio: si accediste a contenido del curso pero de forma mínima (por ejemplo, solo abriste la primera lección introductoria) dentro de las 72 horas, podés escribirnos y evaluamos el caso puntualmente.',
      'Sin reembolso: una vez transcurridas 72 horas desde la compra, o si ya accediste a una parte significativa del contenido del curso (más de una lección completa, o descargaste materiales del curso), no se realizan reembolsos, ya que el contenido digital ya fue entregado y consumido.',
    ],
  },
  {
    id: 'como-solicitar',
    title: '4. Cómo solicitar un reembolso',
    paragraphs: [
      'Escribinos a pagos@tarotmistico.lat indicando: el email o método de pago usado, la fecha aproximada de la compra, el producto (lectura o curso) y el motivo del pedido. Si tenés tu código de recuperación, incluilo para que podamos identificar tu compra más rápido.',
      'Vamos a responder tu solicitud en un plazo de hasta 5 días hábiles.',
    ],
  },
  {
    id: 'medio-reembolso',
    title: '5. Medio y plazo del reembolso',
    paragraphs: [
      'Los reembolsos aprobados se realizan por el mismo medio de pago utilizado en la compra original (Mercado Pago o PayPal). El acreditamiento puede demorar según los tiempos propios de cada plataforma de pago, que están fuera de nuestro control directo.',
    ],
  },
  {
    id: 'referidos-reembolsos',
    title: '6. Impacto en comisiones de referidos',
    paragraphs: [
      'Si una venta que generó una comisión de referido es reembolsada total o parcialmente, la comisión correspondiente se ajusta o anula en la misma proporción del reembolso.',
    ],
  },
  {
    id: 'contacto-reembolsos',
    title: '7. Contacto',
    paragraphs: [
      `Para cualquier consulta sobre esta política, escribinos a pagos@tarotmistico.lat. Última actualización: ${LAST_UPDATED}.`,
    ],
  },
];

const TABS = [
  { id: 'terminos', label: 'Términos y Condiciones', sections: TERMS_SECTIONS },
  { id: 'privacidad', label: 'Política de Privacidad', sections: PRIVACY_SECTIONS },
  { id: 'reembolsos', label: 'Política de Reembolsos', sections: REFUNDS_SECTIONS },
];

const LegalPage = ({ onBack, initialTab }) => {
  const validInitial = TABS.some((t) => t.id === initialTab) ? initialTab : 'terminos';
  const [tab, setTab] = useState(validInitial);
  const [openSectionId, setOpenSectionId] = useState(null);

  const activeTab = TABS.find((t) => t.id === tab) || TABS[0];

  const handleTabChange = (id) => {
    setTab(id);
    setOpenSectionId(null);
  };

  return (
    <div className="page-container">
      <div className="guide-header">
        <h2 className="page-title font-cinzel">📜 Legales</h2>
        <p className="page-subtitle">
          Términos y Condiciones, Política de Privacidad y Política de Reembolsos de Tarot Místico.
          Última actualización: {LAST_UPDATED}.
        </p>
      </div>

      <div className="zodiac-tool-card legal-tool-card">
        <div className="zodiac-tabs">
          {TABS.map((t) => (
            <button
              key={t.id}
              className={`zodiac-tab ${tab === t.id ? 'zodiac-tab--active' : ''}`}
              onClick={() => handleTabChange(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="zodiac-accordion">
          {activeTab.sections.map((section) => {
            const isOpen = openSectionId === section.id;
            return (
              <div
                key={section.id}
                className={`zodiac-accordion-item ${isOpen ? 'zodiac-accordion-item--open' : ''}`}
              >
                <button
                  className="zodiac-accordion-header"
                  onClick={() => setOpenSectionId(isOpen ? null : section.id)}
                >
                  <span>{section.title}</span>
                  <span className="zodiac-accordion-icon">{isOpen ? '−' : '+'}</span>
                </button>
                {isOpen && (
                  <div className="zodiac-accordion-body legal-section-body">
                    {section.paragraphs.map((p, i) => (
                      <p key={i}>{p}</p>
                    ))}
                    {section.list && (
                      <ul className="legal-section-list">
                        {section.list.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    )}
                    {section.paragraphs2 && section.paragraphs2.map((p, i) => (
                      <p key={`p2-${i}`}>{p}</p>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <p className="footer-note legal-ai-disclaimer">✦ {AI_DISCLAIMER}</p>
      </div>

      <button onClick={onBack} className="main-button secondary-button back-btn">
        ← Volver al Inicio
      </button>
    </div>
  );
};

export default LegalPage;
